__turbopack_context__.v({
  "animate": "wz3HWa_animate",
  "cardBack": "wz3HWa_cardBack",
  "cardFront": "wz3HWa_cardFront",
  "container": "wz3HWa_container",
  "faces": "wz3HWa_faces",
  "hasPrices": "wz3HWa_hasPrices",
  "inViewStatus--inView": "wz3HWa_inViewStatus--inView",
  "name": "wz3HWa_name",
  "prices": "wz3HWa_prices",
  "raised": "wz3HWa_raised",
  "shrink-down": "wz3HWa_shrink-down",
  "variant--dfc": "wz3HWa_variant--dfc",
  "variant--partner": "wz3HWa_variant--partner",
});
